// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.properties-panel {
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.properties-panel-empty {
    padding: 40px 20px;
    text-align: center;
    color: #a0aec0;
    font-style: italic;
    font-size: 0.9em;
}

.properties-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #edf2f7;
}

.properties-header h3 {
    margin: 0;
    font-size: 1.25em;
    color: #1a202c;
    font-weight: 700;
}

.element-badge {
    background: #ebf8ff;
    color: #3182ce;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75em;
    font-weight: bold;
    text-transform: uppercase;
}

.prop-section {
    margin-bottom: 15px;
}

.prop-section h4 {
    font-size: 0.85em;
    text-transform: uppercase;
    color: #4a5568;
    margin-bottom: 12px;
    letter-spacing: 0.05em;
    font-weight: 700;
}

.form-group-inline {
    margin-bottom: 10px;
}

.form-group-inline label {
    display: block;
    font-size: 0.8em;
    color: #4a5568;
    margin-bottom: 2px;
    font-weight: 500;
}

.form-group-inline input,
.form-group-inline textarea {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.9em;
    transition: border-color 0.2s;
}

.form-group-inline input:focus,
.form-group-inline textarea:focus {
    outline: none;
    border-color: #4299e1;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.prop-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.btn-delete-element {
    margin-top: auto;
    background: #fff5f5;
    color: #c53030;
    border: 1px solid #feb2b2;
    padding: 10px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9em;
    font-weight: 500;
    transition: all 0.2s;
}

.btn-delete-element:hover {
    background: #c53030;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/MaqueteEditor/PropertiesPanel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".properties-panel {\r\n    padding: 20px;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n}\r\n\r\n.properties-panel-empty {\r\n    padding: 40px 20px;\r\n    text-align: center;\r\n    color: #a0aec0;\r\n    font-style: italic;\r\n    font-size: 0.9em;\r\n}\r\n\r\n.properties-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 15px;\r\n    padding-bottom: 10px;\r\n    border-bottom: 1px solid #edf2f7;\r\n}\r\n\r\n.properties-header h3 {\r\n    margin: 0;\r\n    font-size: 1.25em;\r\n    color: #1a202c;\r\n    font-weight: 700;\r\n}\r\n\r\n.element-badge {\r\n    background: #ebf8ff;\r\n    color: #3182ce;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    font-size: 0.75em;\r\n    font-weight: bold;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.prop-section {\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.prop-section h4 {\r\n    font-size: 0.85em;\r\n    text-transform: uppercase;\r\n    color: #4a5568;\r\n    margin-bottom: 12px;\r\n    letter-spacing: 0.05em;\r\n    font-weight: 700;\r\n}\r\n\r\n.form-group-inline {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.form-group-inline label {\r\n    display: block;\r\n    font-size: 0.8em;\r\n    color: #4a5568;\r\n    margin-bottom: 2px;\r\n    font-weight: 500;\r\n}\r\n\r\n.form-group-inline input,\r\n.form-group-inline textarea {\r\n    width: 100%;\r\n    padding: 8px 10px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 6px;\r\n    font-size: 0.9em;\r\n    transition: border-color 0.2s;\r\n}\r\n\r\n.form-group-inline input:focus,\r\n.form-group-inline textarea:focus {\r\n    outline: none;\r\n    border-color: #4299e1;\r\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\r\n}\r\n\r\n.prop-row {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n}\r\n\r\n.btn-delete-element {\r\n    margin-top: auto;\r\n    background: #fff5f5;\r\n    color: #c53030;\r\n    border: 1px solid #feb2b2;\r\n    padding: 10px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 0.9em;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.btn-delete-element:hover {\r\n    background: #c53030;\r\n    color: white;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
